import { getColorVars } from '../../utils/functions';

interface Props {
  href: string;
  className?: string;
  external?: boolean;
  children: JSX.Element | string | null;
  onClick?: () => void;
}

const Link: React.FC<Props> = (props: Props): JSX.Element => {
  const { textColor } = getColorVars();

  return (
    <a
      href={props.href}
      target={props.external ? '_blank' : ''}
      rel={props.external ? 'noreferrer' : ''}
      className={`${textColor} ${props.className}`}
      onClick={props.onClick}
    >
      {props.children}
    </a>
  );
};

export default Link;
